import React, { Fragment, useState, useEffect } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';

const staticMenus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },
    {
        id: 2,
        title: 'Services',
        link: '#',
        submenu: [] // Will be populated dynamically
    },
    {
        id: 3,
        title: 'Events',
        link: '#',
        submenu: [] // Will be populated dynamically
    },
    {
        id: 4,
        title: 'About Us',
        link: '/about',
    },
    {
        id: 5,
        title: 'Wall of Akhirah',
        link: '/wall-of-akhirah',
    },
    {
        id: 6,
        title: 'Contact Us',
        link: '/contact',
    }
]


const MobileMenu = () => {
    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);
    const [menus, setMenus] = useState(staticMenus);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [servicesRes, eventsRes] = await Promise.all([
                    fetch('/api/services'),
                    fetch('/api/events')
                ]);
                const servicesData = await servicesRes.json();
                const eventsData = await eventsRes.json();

                const services = Array.isArray(servicesData) ? servicesData : [];
                const events = Array.isArray(eventsData) ? eventsData : [];

                setMenus(prevMenus => prevMenus.map(menu => {
                    if (menu.id === 2) {
                        return {
                            ...menu,
                            submenu: services.map((service, index) => ({
                                id: 20 + index,
                                title: service.title,
                                link: `/service-single/${service.slug}`
                            }))
                        };
                    }
                    if (menu.id === 3) {
                        return {
                            ...menu,
                            submenu: events.map((event, index) => ({
                                id: 30 + index,
                                title: event.title,
                                link: `/event-single/${event.slug}`
                            }))
                        };
                    }
                    return menu;
                }));
            } catch (error) {
                console.error('Error fetching navigation data:', error);
            }
        };
        fetchData();
    }, []);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu && item.submenu.length > 0 ?
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <NavLink onClick={ClickHandler} className="active"
                                                                    to={submenu.link}>{submenu.title}</NavLink>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : item.submenu ?
                                        <Fragment>
                                            <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                                <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                            </p>
                                            <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                                <List className="subMenu">
                                                    <ListItem>
                                                        <span style={{padding: '10px', color: '#666'}}>Loading...</span>
                                                    </ListItem>
                                                </List>
                                            </Collapse>
                                        </Fragment>
                                    : <NavLink className="active"
                                        to={item.link}>{item.title}</NavLink>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;
